import { CandidateAboutDTO, CandidateAvatarDTO, CandidateProfileDTO } from "@core/dto";
import { DatesHelpers, EncodingHelpers } from "@core/helpers";
import { Filesystem, CordovaFileOpener } from "@core/plugins/mobile";
import api from "@core/plugins/api";

const candidateProfileUrl = () => `/ex/candidate-personal-information`;
const updateCandidateAvatarUrl = () => `/ex/candidate-personal-information/picture`;
const updateCandidateAboutUrl = () => `/ex/candidate-personal-information/about`;
const downloadResumeUrl = () => `/ex/candidate-personal-information/download`;

export class CandidateProfileService {
  static async getProfile() {
    try {
      const { data } = await api.private.get(candidateProfileUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async savePersonalInformations({ profile }) {
    try {
      const dto = new CandidateProfileDTO(profile);
      const profileToUpdate = dto.prepareInformationData();
      return api.private.put(candidateProfileUrl(), profileToUpdate);
    } catch (error) {
      throw error;
    }
  }

  static async updateProfilePicture({ avatar }) {
    try {
      const dto = new CandidateAvatarDTO({ avatar });
      const avatarToUpdate = dto.prepareProfilePictureData();
      return api.comet.put(updateCandidateAvatarUrl(), avatarToUpdate);
    } catch (error) {
      throw error;
    }
  }

  static async updateProfileAbout({ about }) {
    try {
      const dto = new CandidateAboutDTO({ about });
      const aboutToUpdate = dto.prepareAboutData();
      return api.comet.put(updateCandidateAboutUrl(), aboutToUpdate);
    } catch (error) {
      throw error;
    }
  }

  static async downloadResume() {
    try {
      const { data } = await api.private.get(downloadResumeUrl(), { responseType: "blob" });
      const pdfBlob = new Blob([data], { type: "application/pdf" });
      const fileName = `extracadabra-cv.pdf`;
      const fileURL = window.URL.createObjectURL(pdfBlob);
      const anchor = document.createElement("a");
      anchor.href = fileURL;
      anchor.target = "_blank";
      anchor.download = fileName;
      anchor.click();
    } catch (error) {
      throw error;
    }
  }

  static async downloadResumeMobile() {
    try {
      const { data } = await api.private.get(downloadResumeUrl(), { responseType: "blob" });
      const file = new Blob([data], { type: "application/pdf" });
      // fix error on android when trying to download twice a file with the same filename
      const currentDatetime = DatesHelpers.formatToFullDate(DatesHelpers.getDayjs(), "YYYYMMDDHHmmss");
      const fileName = `extracadabra-cv-${currentDatetime}.pdf`;
      const base64File = await EncodingHelpers.getBase64FromFile(file);

      const savedFile = await Filesystem.writeFile({
        path: fileName,
        data: base64File,
      });

      CordovaFileOpener.plugin.showOpenWithDialog(savedFile.uri, "application/pdf", {
        error(e) {
          console.log(`Error status: ${e.status} - Error message: ${e.message}`);
        },
      });
    } catch (error) {
      throw error;
    }
  }
}
